import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=c731900e&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=c731900e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c731900e",
  null
  
)

export default component.exports